import { createAction } from 'redux-actions'
import { GET_ORDERS } from '../../constants/actionType'
import order from '../../services/api/order'

const getOrdersAction = createAction(GET_ORDERS)

export const getOrderHistories = (merchantId, isFilteredByMe) => async (dispatch, getState) => {
  try {
    const data = await order.listOrders(merchantId, isFilteredByMe)
    data.forEach((order) => {
      order.items = order.items.map((item) => ({
        dish: item.name,
        dishId: item.menuId,
        options: item.options,
        price: item.price,
        quantity: item.quantity,
        total: item.total,
        cancelled: item.cancelled,
        priceUndetermined: item.priceUndetermined,
        remarks: item.remarks,
      }))
      const tmp = order.customItems.map((item) => ({
        dish: item.name,
        dishId: item.menuId,
        options: item.options,
        price: item.price,
        quantity: item.quantity,
        total: item.total,
        priceUndetermined: item.priceUndetermined,
      }))
      order.items.push(...tmp)
    })

    // check state changes under poop network conditions
    var currIsFilteredByMe = getState().basket.isFilteredByMe
    if (isFilteredByMe === currIsFilteredByMe) {
      dispatch(getOrdersAction(data))
    }
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/history.js